import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import cc from 'classcat';
import PropTypes from 'prop-types';
import React from 'react';
import LazyImg from '../LazyImg';
import css from './MessageScroller.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MessageScroller = /*#__PURE__*/function (_React$Component) {
  _inherits(MessageScroller, _React$Component);

  var _super = _createSuper(MessageScroller);

  function MessageScroller(props) {
    var _this;

    _classCallCheck(this, MessageScroller);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onSlideIntersect", function (entries) {
      var currentIndex = _this.state.index;
      entries.forEach(function (entry) {
        var intersectionRatio = entry.intersectionRatio,
            isIntersecting = entry.isIntersecting,
            target = entry.target;
        var parent = target.parentNode;
        var index = Array.prototype.indexOf.call(parent.children, target);
        var inBounds = isIntersecting && intersectionRatio > 0.58;

        if (inBounds && currentIndex !== index) {
          _this.setState({
            index: index
          });
        }

        if (!inBounds && index === 1 && currentIndex === 1 && !isIntersecting) {
          _this.setState({
            index: 0
          });
        }
      });
    });

    var messages = _this.props.messages;
    messages.forEach(function (message, index) {
      _this["slide-".concat(index)] = /*#__PURE__*/React.createRef();
    });
    _this.state = {
      index: 0
    };
    return _this;
  }

  _createClass(MessageScroller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var messages = this.props.messages;
      var observer = new IntersectionObserver(this.onSlideIntersect, {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0]
      });
      messages.forEach(function (message, index) {
        var slideRef = _this2["slide-".concat(index)];

        if (!slideRef || !slideRef.current) {
          return;
        }

        var slide = slideRef.current;
        observer.observe(slide);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          messageBot = _this$props.messageBot,
          messages = _this$props.messages,
          messageTop = _this$props.messageTop,
          mobileSafari = _this$props.mobileSafari;
      var index = this.state.index;
      var translateY = -1 * index * Math.round(100 / (messages.length + 1));
      var messageInnerStyle = {
        transform: "translate3d(0, ".concat(translateY, "%, 0)")
      };
      return /*#__PURE__*/_jsxs("section", {
        className: css.root,
        children: [/*#__PURE__*/_jsxs("div", {
          className: cc([css.topMessage, _defineProperty({}, css.mobileSafari, mobileSafari)]),
          children: [messages.map(function (m, mIndex) {
            var alt = m.alt,
                id = m.id,
                image = m.image,
                imageStyle = m.imageStyle,
                message = m.message,
                mobileClass = m.mobileClass;

            if (!image) {
              return null;
            }

            var imageTranslateY = 100;

            if (index - 1 === mIndex) {
              imageTranslateY = 0;
            }

            if (index - 1 > mIndex) {
              imageTranslateY = -100;
            }

            return /*#__PURE__*/_jsx("div", {
              className: css.imageWrap,
              style: {
                transform: "translate3d(0, ".concat(imageTranslateY, "%, 0)")
              },
              children: /*#__PURE__*/_jsx(LazyImg, {
                alt: alt || message,
                className: cc([css.image, css[mobileClass]]),
                src: image,
                style: imageStyle
              })
            }, id);
          }), /*#__PURE__*/_jsx("p", {
            className: css.copyLine,
            children: messageTop
          }), /*#__PURE__*/_jsx("div", {
            className: css.messageHolder,
            children: /*#__PURE__*/_jsxs("div", {
              className: css.messageHolderInner,
              style: messageInnerStyle,
              children: [/*#__PURE__*/_jsx("p", {
                className: cc([css.copyLine, css.copyLineGhost])
              }), messages.map(function (m) {
                return /*#__PURE__*/_jsx("p", {
                  className: css.copyLine,
                  children: m.message
                }, "message-".concat(m.id));
              })]
            })
          }), /*#__PURE__*/_jsx("p", {
            className: css.copyLine,
            children: messageBot
          })]
        }), messages.map(function (m, mIndex) {
          var slideStyle = {
            marginTop: mIndex === 0 ? '-33vh' : null
          };
          return /*#__PURE__*/_jsx("div", {
            className: css.slide,
            ref: _this3["slide-".concat(mIndex)],
            style: slideStyle
          }, "slide-".concat(m.id));
        })]
      });
    }
  }]);

  return MessageScroller;
}(React.Component);

MessageScroller.propTypes = {
  messageBot: PropTypes.string.isRequired,
  messageTop: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  mobileSafari: PropTypes.bool.isRequired
};
export default MessageScroller;